import { useEffect, useState } from 'react';
import PageTitle from '../../components/PageTitle';
import ProjectCard from '../../components/ProjectCard';
import { projectService } from '../../services/projectService';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

const OurProjects = () => {
  useDocumentTitle("Our Projects");
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchAsync();
  }, []);

  const fetchAsync = async () => {
    try {
      setError("");
      setLoading(true);
      const response = await projectService.getPublishedAsync();
      if (!response.isSuccess) {
        setError(response.errors?.[0] || "Unable to load projects right now. Please try again later.");
        setProjects([]);
        return;
      }
      setProjects(response.value || []);
    } catch (err) {
      setError("Unable to load projects right now. Please try again later.");
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageTitle title="Our Projects" />
      <section className="blog-section pt-120 pb-120">
        <div className="auto-container">
          {loading && (
            <div className="row">
              <div className="col-12 text-center">
                <p>Loading projects...</p>
              </div>
            </div>
          )}

          {!loading && error && (
            <div className="row">
              <div className="col-12 text-center">
                <p>{error}</p>
              </div>
            </div>
          )}

          {!loading && !error && projects.length === 0 && (
            <div className="row">
              <div className="col-12 text-center">
                <p>Project information is currently unavailable.</p>
              </div>
            </div>
          )}

          {!loading && !error && projects.length > 0 && (
            <div className="row g-4">
              {projects.map((project, index) => (
                <ProjectCard key={project.id} project={project} animationDelay={`${(index % 3) * 100}ms`} />
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default OurProjects;
